import {FlexBox} from "@brg/ui";
import {
    BookCardsCaption,
    BookCardsTitle,
    BookCardsWrapper,
    EmptyCardsDescription,
    EmptyCardsTitle
} from "./styles";
import {FC} from "react";
import {BookCardList} from "./BookCardList";
import {MINIMUM_CARDS_FOR_QUEUE} from "../../BookEdit";
import { useTranslation } from "react-i18next";


export const BookCards: FC<{cards: any[], activeCardIds?: string[], setActiveCardIds?: (val: string[]) => void, disabled?: boolean, setIsCardsUpdateIsLoading?: (val: boolean) => void, bookId?: string}> = ({bookId, cards, activeCardIds, setActiveCardIds, disabled, setIsCardsUpdateIsLoading}) => {
    const { t } = useTranslation();
    return (
        <BookCardsWrapper width="100%" direction="column" directionMobile="column" gy={cards?.length > 0 ? 24 : 56}>
            <FlexBox justify="space-between" align="center">
                <FlexBox gx={24}>
                    <BookCardsTitle>{t('book_edit.cards_block.title')}</BookCardsTitle>
                    {activeCardIds !== undefined && activeCardIds?.length < MINIMUM_CARDS_FOR_QUEUE && !disabled && <BookCardsCaption>{t('book_edit.cards_block.min_max_text')} {MINIMUM_CARDS_FOR_QUEUE}</BookCardsCaption>}
                </FlexBox>
            </FlexBox>
            {cards?.length > 0 ? <BookCardList
                    setIsCardsUpdateIsLoading={setIsCardsUpdateIsLoading} bookId={bookId}
                activeCardIds={activeCardIds} setActiveCardIds={setActiveCardIds}
                cards={cards} isEditMode={activeCardIds !== undefined && !disabled}/>
                : <FlexBox direction="column" directionMobile="column" width="100%" justify="center">
                    <EmptyCardsTitle>
                        {t('book_edit.cards_block.subtitle')}
                    </EmptyCardsTitle>
                    <EmptyCardsDescription offsetTop={8}>
                        {t('book_edit.cards_block.description')}
                    </EmptyCardsDescription>
                </FlexBox>}
        </BookCardsWrapper>
    )
}

export const BookCardsWithPay: FC<{cards: any[]}> = ({cards}) => {
    const { t } = useTranslation();
    
    return (
        <BookCardsWrapper width="100%" direction="column" directionMobile="column" gy={24}>
            <FlexBox justify="space-between" align="center">
                <FlexBox gx={24}>
                    <BookCardsTitle>{t('book_edit.collection_cards')}</BookCardsTitle>
                </FlexBox>
            </FlexBox>
            <BookCardList
                cards={cards} isEditMode={false}/>
        </BookCardsWrapper>
    )
}import {FlexBox} from "@brg/ui";
import {
    BookCardsCaption,
    BookCardsTitle,
    BookCardsWrapper,
    EmptyCardsDescription,
    EmptyCardsTitle
} from "./styles";
import {FC} from "react";
import {BookCardList} from "./BookCardList";
import {MINIMUM_CARDS_FOR_QUEUE} from "../../BookEdit";
import { useTranslation } from "react-i18next";


export const BookCards: FC<{cards: any[], activeCardIds?: string[], setActiveCardIds?: (val: string[]) => void, disabled?: boolean, setIsCardsUpdateIsLoading?: (val: boolean) => void, bookId?: string}> = ({bookId, cards, activeCardIds, setActiveCardIds, disabled, setIsCardsUpdateIsLoading}) => {
    const { t } = useTranslation();
    return (
        <BookCardsWrapper width="100%" direction="column" directionMobile="column" gy={cards?.length > 0 ? 24 : 56}>
            <FlexBox justify="space-between" align="center">
                <FlexBox gx={24}>
                    <BookCardsTitle>{t('book_edit.cards_block.title')}</BookCardsTitle>
                    {activeCardIds !== undefined && activeCardIds?.length < MINIMUM_CARDS_FOR_QUEUE && !disabled && <BookCardsCaption>{t('book_edit.cards_block.min_max_text')} {MINIMUM_CARDS_FOR_QUEUE}</BookCardsCaption>}
                </FlexBox>
            </FlexBox>
            {cards?.length > 0 ? <BookCardList
                    setIsCardsUpdateIsLoading={setIsCardsUpdateIsLoading} bookId={bookId}
                activeCardIds={activeCardIds} setActiveCardIds={setActiveCardIds}
                cards={cards} isEditMode={activeCardIds !== undefined && !disabled}/>
                : <FlexBox direction="column" directionMobile="column" width="100%" justify="center">
                    <EmptyCardsTitle>
                        {t('book_edit.cards_block.subtitle')}
                    </EmptyCardsTitle>
                    <EmptyCardsDescription offsetTop={8}>
                        {t('book_edit.cards_block.description')}
                    </EmptyCardsDescription>
                </FlexBox>}
        </BookCardsWrapper>
    )
}

export const BookCardsWithPay: FC<{cards: any[]}> = ({cards}) => {
    const { t } = useTranslation();
    
    return (
        <BookCardsWrapper width="100%" direction="column" directionMobile="column" gy={24}>
            <FlexBox justify="space-between" align="center">
                <FlexBox gx={24}>
                    <BookCardsTitle>{t('book_edit.collection_cards')}</BookCardsTitle>
                </FlexBox>
            </FlexBox>
            <BookCardList
                cards={cards} isEditMode={false}/>
        </BookCardsWrapper>
    )
}